import { Injectable } from "@angular/core";
import { Action } from "../model/action";
import { Notes, AdminPost } from "../model/notes";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";
@Injectable()
export class NoteService {
  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  data: Notes;
  dataPost: AdminPost;
  profilePic: any[];
  constructor(http: HttpClientService, cook: CookiesService) {
    this.http = http;
    this.cookie = cook;
    this.objAction = new Action(this.http, this.cookie);
  }
  saveNotes(): Observable<Notes> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Notes/CreateNotes";
    return this.objAction.save();
  }
  getNotes(): Observable<Notes[]> {
    this.objAction.path = "api/Notes/GetNotes";
    return this.objAction.get();
  }

  sendNotification(id: number): Observable<unknown> {
    this.objAction.path = "api/Notes/SendNotification?id=" + id;
    return this.objAction.get();
  }
  updateNotes(): Observable<Notes> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Notes/UpdateNotes";
    return this.objAction.update();
  }
  deleteNotes(org: Notes): Observable<Notes> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Notes/DeleteNotes?strNotesId=" + org.NotesId;
    return this.objAction.delete();
  }

  saveAdminPost(): Observable<AdminPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path = "api/Notes/CreateAdminPost";
    return this.objAction.save();
  }
  updateAdminPost(): Observable<AdminPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path = "api/Notes/UpdateAdminPost";
    return this.objAction.update();
  }
  getAdminPost(): Observable<AdminPost[]> {
    this.objAction.path = "api/Notes/GetAdminPost";
    return this.objAction.get();
  }
  getAdminPostData(id: number): Observable<AdminPost[]> {
    this.objAction.path = "api/Notes/GetAdminPost?id=" + id;
    return this.objAction.get();
  }

  saveAdminPostPic(): Observable<AdminPost> {
    this.objAction.path = "api/Notes/UpdatePostPic";
    this.objAction.data = this.dataPost;
    this.objAction.files = this.profilePic;
    return this.objAction.saveDataWithFiles();
  }

  deleteAdminPost(objAdminPost: AdminPost): Observable<AdminPost> {
    this.objAction.header = null;
    this.objAction.data = this.dataPost;
    this.objAction.path =
      "api/Notes/DeleteAdminPost?strPostId=" + objAdminPost.PostId;
    return this.objAction.delete();
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/services/note.service.ts